import HttpService from "./httpService";

export interface GuestAccessTokenResponse {
  access_token: string;
  expires_in: number;
}

export const GUEST_ACCESS_TOKEN_ENDPOINT =
  "/ucc-software/v2/checkout/guest-access-token";

export const mintGuestAccessToken = (
  httpService: HttpService,
  email: string
): Promise<GuestAccessTokenResponse> =>
  httpService.post<GuestAccessTokenResponse>(
    GUEST_ACCESS_TOKEN_ENDPOINT,
    { email },
    { "content-type": "application/json" }
  );
